<app-header [pageTitle]="pageTitle" (back)="goBack()"></app-header>
<ion-content>
  <div class="upper-content-wrapper">
    <p class="recent-transaction">{{ "cashout-status.Recent" | translate }}</p>
  </div>
  @if (cashOutData$ | async; as cashOutStatus) {
    <div class="lower-content-wrapper">
      @if (cashOutStatus && cashOutStatus?.length > 0) {
        <div>
          @for (cashOutStatusDetail of cashOutStatus; track cashOutStatusDetail) {
            @if (cashOutStatusDetail?.type === 'PayPal') {
              <ion-row class="splitter-line-bottom transaction-type">
                <ion-col size="1" class="ion-no-padding image-alignment">
                  <img src="../../../../assets/icon/color@3x.png" class="image-size" alt="" />
                </ion-col>
                <ion-col size="11">
                  <ion-row class="transaction">
                    <ion-col class="transaction-heading" size="9">
                      <h2 class="transaction-heading-content">{{ "cashout-status.PayPal" | translate }}</h2>
                    </ion-col>
                    <ion-col class="transaction-amount" size="3">
                      <p class="transaction-value">
                        {{ isPayPalCurrencyINR ? paypalCurrencySymbol : currencySymbol }}{{ (isPayPalCurrencyINR ? cashOutStatusDetail?.value : cashOutStatusDetail?.preferred_currency?.value ?? cashOutStatusDetail?.value) | displayCurrency }}
                      </p>
                      <!-- <p class="transaction-value">{{currencySymbol}}{{ cashOutStatusDetail?.value.toFixed(2) }}</p> -->
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col class="transaction-info" size="8">
                      <p class="transaction-info-content">{{ cashOutStatusDetail?.detail_status | capitalizeFirst }}</p>
                    </ion-col>
                    <ion-col class="transaction-status" size="4">
                      <ion-chip
                        class="transaction-status-chip"
                  [ngClass]="{
                    'declained-chip': cashOutStatusDetail?.status === 'declined',
                    'processed-chip': cashOutStatusDetail?.status === 'processed',
                    'pending-chip': cashOutStatusDetail?.status === 'pending'
                  }"
                        >
                        <ion-label class="transaction-status-chip-text">{{
                          cashOutStatusDetail?.status | capitalizeFirst
                        }}</ion-label>
                      </ion-chip>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            }
            @if (cashOutStatusDetail?.type === 'Convert to Credit') {
              <ion-row
                class="splitter-line-bottom transaction-type"
                >
                <ion-col size="1" class="ion-no-padding image-alignment">
                  <img src="../../../../assets/icon/dark_credit.svg" class="image-size" alt="" />
                </ion-col>
                <ion-col size="11">
                  <ion-row class="transaction">
                    <ion-col class="transaction-heading" size="9">
                      <h2 class="transaction-heading-content">{{ "cashout-status.Credits" | translate }}</h2>
                    </ion-col>
                    <ion-col class="transaction-amount" size="3">
                      <p class="transaction-value">{{currencySymbol}}{{
                      (cashOutStatusDetail?.preferred_currency?.value ?? cashOutStatusDetail?.value) | displayCurrency }}</p>
                      <!--  <p class="transaction-value">{{currencySymbol}}{{cashOutStatusDetail?.value.toFixed(2) }}</p> -->
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col class="transaction-info" size="8">
                      <p class="transaction-info-content">{{ getTranslatedText(cashOutStatusDetail?.detail_status) | capitalizeFirst }}</p>
                    </ion-col>
                    <ion-col class="transaction-status" size="4">
                      <ion-chip
                        class="transaction-status-chip"
                  [ngClass]="{
                    'declained-chip': cashOutStatusDetail?.status === 'declined',
                    'processed-chip': cashOutStatusDetail?.status === 'processed',
                    'pending-chip': cashOutStatusDetail?.status === 'pending'
                  }"
                        >
                        <ion-label>{{ (('cashout.' + cashOutStatusDetail?.status) | translate) | capitalizeFirst }}</ion-label>
                      </ion-chip>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            }
            @if (cashOutStatusDetail?.type === 'Donate to Charity') {
              <ion-row
                class="splitter-line-bottom transaction-type"
                >
                <ion-col size="1" class="ion-no-padding image-alignment">
                  <img src="../../../../assets/icon/color.svg" class="image-size" alt="" />
                </ion-col>
                <ion-col size="11">
                  <ion-row class="transaction">
                    <ion-col class="transaction-heading" size="9">
                      <h2 class="transaction-heading-content">{{ "cashout-status.Charity" | translate }}</h2>
                    </ion-col>
                    <ion-col class="transaction-amount" size="3">
                      <p class="transaction-value">{{currencySymbol}}{{
                      (cashOutStatusDetail?.preferred_currency?.value ?? cashOutStatusDetail?.value) | displayCurrency }}</p>
                      <!--  <p class="transaction-value">{{currencySymbol}}{{ cashOutStatusDetail?.value.toFixed(2) }}</p> -->
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col class="transaction-info" size="8">
                      <p class="transaction-info-content">{{ cashOutStatusDetail?.detail_status | capitalizeFirst }}</p>
                    </ion-col>
                    <ion-col class="transaction-status" size="4">
                      <ion-chip
                        class="transaction-status-chip"
                  [ngClass]="{
                    'declained-chip': cashOutStatusDetail?.status === 'declined',
                    'processed-chip': cashOutStatusDetail?.status === 'processed',
                    'pending-chip': cashOutStatusDetail?.status === 'pending'
                  }"
                        >
                        <ion-label>{{ cashOutStatusDetail?.status | capitalizeFirst }}</ion-label>
                      </ion-chip>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            }
          }
        </div>
      } @else {
        <div class="image">
          <img src="assets/icon/cashout-emtpy.svg" alt="cashOutEmpty" />
        </div>
        <div class="no-cashout-transaction-wrapper">
          <p class="no-cashout-transaction">{{ "cashout-status.cash" | translate }}</p>
        </div>
      }
    </div>
  }
</ion-content>
